/* eslint-disable */
import logo from './logo.svg';
import './App.css';
import LoginPage from './Page/LoginPage'
// import 'antd/dist/antd.min.css';
import Router from "./routes/router";


function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
